import { validateConditionaly } from '@sravni/cosago-react-library/lib/validationSchemes';
import { ADDITIONAL_PHONE_OWNER_VALUES } from '@sravni/creditselection-customer-utils/lib/utils/customers';
import type { AnySchema } from 'yup';
import { mixed } from 'yup';

import type { TAdditionalDataFormFields } from 'entities/creditForm';

export const validateAdditionalPhoneOwnerFio = (fieldSchema: AnySchema, otherwiseSchema?: AnySchema) =>
  validateConditionaly<TAdditionalDataFormFields['additionalPhoneOwnerFullName']>(
    (additionalPhoneOwner: TAdditionalDataFormFields['additionalPhoneOwner']) => {
      if (!additionalPhoneOwner?.value) {
        return false;
      }
      const additionalPhoneOwnerValue = String(additionalPhoneOwner?.value) as ValuesOf<
        typeof ADDITIONAL_PHONE_OWNER_VALUES
      >;
      return additionalPhoneOwnerValue !== ADDITIONAL_PHONE_OWNER_VALUES.MY_NUMBER;
    },
    () => fieldSchema,
    () => otherwiseSchema || mixed().nullable().optional(),
  )('additionalPhoneOwner');
